(ns app.front.view.workspace.action-subs
  (:require [app.front.view.application.utils :as app-utils]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::actions
  (fn [[_ process-sub] _]
    (rf/subscribe process-sub))
  (fn [process _]
    (app-utils/resolve-primary-actions process true)))

(rf/reg-sub ::actions-for-signal
  (fn [[_ process-sub] _]
    (rf/subscribe [::actions process-sub]))
  (fn [actions [_ _ signal-id]]
    (->> actions
         (filter #(-> % :signal-id (= signal-id))))))

(defn all-errors [actions _]
  (->> actions
       (filter #(= (:status %) :disabled))
       (mapcat :errors)
       distinct))

(rf/reg-sub ::all-errors
  (fn [[_ process-sub] _]
    (rf/subscribe [::actions process-sub]))
  all-errors)

(defn all-error-ids [all-errors _]
  (->> all-errors
       (map first)
       set))

(rf/reg-sub ::all-error-ids
  (fn [[_ process-sub] _]
    (rf/subscribe [::all-errors process-sub]))
  all-error-ids)
